import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "semantic-ui-react";
import { pdApiActions } from "../../../actions/pdApiActions";
import DropdownField from "../../../components/Editing/DropdownField";
import { getVersionOptions } from "../../../utils/pdApiUtils";

const VersionFilter: React.FC = () => {
  const pdApi = useSelector((state: State.Root) => state.pdApi);
  const versionOptions =  getVersionOptions(pdApi.DoorVersions,pdApi.domains);
  const filterOptions = useSelector((state: State.Root) => state.filterOptions);
  const dispatch = useDispatch();

  return (
    <Form className="filterForm">
      <DropdownField
        id="versionFilter"
        label="Version"
        value={filterOptions.selectedDoorVersion}
        options={versionOptions}
        onChange={id => {
          dispatch(
            pdApiActions.setFilterOptions({
              ...filterOptions,
              selectedDoorVersion: id
            })
          );
        }}
      />
    </Form>
  );
};

export default VersionFilter;
